// removed by extract-text-webpack-plugin
module.exports = {"stepTitle":"_-src-components-NewUserSegment-components-ReviewStep-index---stepTitle---GC_Ob","stepBody":"_-src-components-NewUserSegment-components-ReviewStep-index---stepBody---y8o0Q","propertyTitle":"_-src-components-NewUserSegment-components-ReviewStep-index---propertyTitle---2Fnsf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewUserSegment/components/ReviewStep/index.css
// module id = 829
// module chunks = 1